// export constants used throughout the program to avoid working with strings.
export const setCampaignsQuery = "setCampaignsQuery";
export const setCampaignsRoFQuery = "setCampaignsRoFQuery";
export const setCampaignsExcludedCampaigns = "setCampaignsExcludedCampaigns";
export const setCampaignsResults = "setCampaignsResults";
export const setCampaignsResultsColumns = "setCampaignsResultsColumns";
export const setCampaignsResultsAggregationTypes =
  "setCampaignsResultsAggregationTypes";
export const setCampaignsSummary = "setCampaignsSummary";
export const setCampaignsColumnTypes = "setCampaignsColumnTypes";
export const setCampaignsInitStatus = "setCampaignsInitStatus";
export const setCampaignsQueryForAPI = "setCampaignsQueryForAPI";
export const setCampaignsTimeshift = "setCampaignsTimeshift";
export const setCampaignsChannels = "setCampaignsChannels";
export const setCampaignsRoFResults = "setCampaignsRoFResults";
export const setCampaignsRoFResultsLoadDetails =
  "setCampaignsRoFResultsLoadDetails";
export const setCampaignsStartdate = "setCampaignsStartdate";
export const setCampaignsEnddate = "setCampaignsEnddate";
export const setCampaignsMeasures = "setCampaignsMeasures";
export const setCampaignsSpottypes = "setCampaignsSpottypes";
export const setCampaignsColumnFieldsOptions =
  "setCampaignsColumnFieldsOptions";
export const setCampaignsDisplayColumnFieldsOptions =
  "setCampaignsDisplayColumnFieldsOptions";
export const setCampaignsAllWithStarSelected =
  "setCampaignsAllWithStarSelected";
export const setCampaignsSumVisible = "setCampaignsSumVisible";
export const setCampaignsGroupBy = "setCampaignsGroupBy";
export const setQueryCostData = "setCampaignsQueryCostData";
export const setQueryCostLoading = "setCampaignsQueryCostLoading";
export const setQueryCostError = "setCampaignsQueryCostError";
export const setCampaignsQueryBeforeChange = "setCampaignsQueryBeforeChange";
export const setCampaignsStringForFilterBeforeChange =
  "setCampaignsStringForFilterBeforeChange";
export const setDefaultCampaignsQuery = "setDefaultCampaignsQuery";
export const setHasSetDefaultCampaignsQuery = "setHasSetDefaultCampaignsQuery";
